function Notice( { message, type } ) {
	return <div className={ `woocommerce-${ type }` } role="alert">
		{ message }
	</div>;
}

export default Notice;
